// derived from https://github.com/vestwell/sub-accounting-core/blob/e08574ca07106f9dc1bc10e21f9377a81b38b1f9/src/models/accountsAndLedgers/PlanApiIncludeOption.ts

export enum SubaPlanIncludeOption {
  marketValueAndCashBalance = 'marketValueAndCashBalance',
  subAccountDebitCash = 'subAccountDebitCash',
  subAccountShortPositions = 'subAccountShortPositions'
}
